import "../../App.scss";

import React from "react";
import styled from "styled-components";

const Warper = styled.div`
  display: flex;
  overflow : scroll ;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;

const Title = styled.h4`
  display: flex;
  width: 90%;
  align-items: center;
  text-align: right;
  justify-content: flex-end;
  color: #009544;
  font-family: "Vista";
  margin-top: 10px;
`;
const Start = styled.h3`
  display: flex;
  width: 90%;
  align-items: center;
  text-align: justify;
  justify-content: center;
  color: #4b4b45;
  font-family: "Vista";
  margin-top: 10px;
`;
const Text = styled.h5`
  display: flex;
  width: 90%;
  align-items: center;
  text-align: justify;
  justify-content: center;
  color: #4b4b45;
  font-family: "Vista";
  margin-top: 10px;
  direction: rtl;
`;

export default function Privacy() {
  return (
    <Warper>
      <Start>به نام خدا</Start>
      <Title>سیاست حفظ حریم خصوصی اپلیکیشن شبکه خیر</Title>
      <Text>
        1) کاربران با ثبت‌نام در اپلیکیشن شبکه خیر، همچنین با هر بار استفاده از
        خدمات آن، می‌پذیرند که شرایط و قوانین حاضر را به صورت کامل مطالعه کرده و
        آن را با اطلاع کامل از شرایط و معانی‌اش پذیرفته‌اند. این شرایط و قوانین
        ممکن است در طول زمان تغییر کند. استفاده کاربران از اپلیکیشن، پس از هر
        بار تغییر در شرایط و قوانین، به معنی پذیرش تغییرات مذکور است. این قوانین
        داخل اپلیکیشن و نیز در سایت راهنمای اپلیکیشن برای مطالعه کاربران در
        دسترس است.
      </Text>
      <Text>
        2) اطلاعات کاربری نزد کاربرانی که از خدمات اپلیکیشن شبکه خیر استفاده
        می‌کنند، محرمانه بوده و هیچ یک از کاربران حق ندارند اطلاعات مربوط به
        حساب طرف مقابل را (اعم از مشخصات هویتی، کد ملی، شماره تماس، آدرس، عکس و
        غیره) ذخیره، یا منتشر کند و در دسترس دیگران قرار دهد.
      </Text>
      <Text>
        3) یکی از سیاست های اصلی اپلیکیشن شبکه خیر، حفظ اسرار کاربران است و ضمن
        احترام به حریم خصوصی کاربران، بدین وسیله عدم نشر و حفظ اسرار کاربران و
        موسسات را تعهد می‌نماید
      </Text>
      <Text>
        4) اپلیکیشن ممکن است برای دسترسی به تقویم، دوربین، گالری، مکان،
        میکروفون، تلفن، اس ام اس، فضای ذخیره سازی و مخاطبین از شما اجازه درخواست
        دسترسی داشته باشد. هنگامی‌که قصد بارگذاری پیام صوتی یا فایل را برای
        کاربران شبکه داشته باشید یا بخواهید عکس پروفایل خود را بارگذاری کنید از
        شما درخواست خواهد شد که برای بررسی‌های بیش‌تر، اجازه دسترسی به دوربین یا
        میکروفن یا فایل‌های ذخیره‌شده را به اپلیکیشن بدهید که تنها با تایید شما،
        موارد انتخابی توسط شما بارگذاری خواهند شد و اجازه درخواست دسترسی مورد
        استفاده دیگری نخواهند داشت. همچنین اپلیکیشن برای اهداف تبلیغاتی از طریق
        ایمیل، تلفن یا پیام متنی با شما تماس برقرار نخواهد کرد و اجازه دسترسی به
        اس ام اس یا ایمیل، تنها برای فعال‌سازی اطلاع‌رسانی خواهد بود.
      </Text>
      <Text>
        5) برای استفاده از خدمات اپلیکیشن شبکه خیر لازم است که هر کاربر حقیقی یک
        حساب کاربری در اپلیکیشن بسازد. تنها اشخاصی که از طرف مدیریت و پشتیبانی
        اپلیکیشن، واجد شرایط قانونی شناخته شده باشند، می‌توانند اقدام به ساخت
        حساب کاربری در اپلیکیشن کنند و ورود افراد غیرمجاز در شبکه میسر نیست.
        کاربر مذکور برای استفاده از خدمات باید نام، نام خانوادگی، شماره تلفن
        همراه و همچنین تاریخ تولد خود را به واحد پشتیبانی اپلیکیشن اعلام کرده تا
        حساب کاربری از طرف ادمین شبکه برایش ساخته شود.
      </Text>
      <Text>
        6) در حال حاضر امکان ایجاد حساب کاربری مستقیم برای کاربران حقوقی وجود
        ندارد و کاربران شخص حقوقی مکلف به معرفی نماینده (شخص حقیقی) برای ثبت‌نام
        در اپلیکیشن هستند و اطلاعات این شخص حقوقی باید در اپلیکیشن قید شود.
      </Text>
      <Text>
        7)شما با ثبت نام در اپلیکیشن، مشخصات خود از قبیل نام و نام خانوادگی،
        تلفن تماس و تاریخ تولد خود را در اختیار اپلیکیشن قرار می‌دهید. در ادامه
        برای تکمیل مشخصات کاربری، نیاز به اضافه کردن عکس پروفایل خود خواهید
        داشت. شما پس از ثبت نام در اپلیکیشن، به عنوان کاربر اپلیکیشن شناخته
        خواهید شد. از آن‌جایی‌که ورود به اپلیکیشن نیازمند احراز هویت اشخاص از
        سمت پشتیبانی شبکه می‌باشد و افراد متفرقه امکان ورود به اپلیکیشن و مشاهده
        یا استفاده از آن را نخواهند داشت، کلیه اطلاعات مذکور و اطلاعاتی مانند
        توانمندی‌ها و نیازمندی‌های ثبت‌شده توسط شما در اختیار کلیه کاربران شبکه
        نیز قرار خواهد گرفت.
      </Text>
      <Text>
        8) هیچ یک از کاربران حق استفاده از ربات و نرم‌‌افزارهای مرتبط یا واسط را
        برای استفاده از اپلیکیشن اعم از احراز هویت، تکمیل اطلاعات، ارسال درخواست
        و غیره ندارند.
      </Text>
      <Text>
        9) کاربران می‌پذیرند کلیه اطلاعات درخواستی اپلیکیشن را مطابق با واقعیت،
        به مرکز پشتیبانی اعلام کنند و شخص کاربر مسئول عدم صحت اطلاعات است. در
        صورت اثبات خلاف این موضوع، اپلیکیشن هیچ‌گونه مسئولیتی در مورد خسارات و
        مشکلات ناشی از عدم اعتبار اطلاعات اعلامی بر عهده نخواهد داشت.
      </Text>
      <Text>
        10) کاربران متعهد می‌شوند که صرفا با شماره تلفن همراه متعلق به خود در
        اپلیکیشن ثبت‌نام کنند. در غیر این صورت در برابر شخص ذی‌نفع صاحب تلفن
        همراه و کد ملی تماما مسئول بوده و مدیریت به محض آگاهی از این موضوع، مجاز
        خواهد بود نسبت به لغو عضویت و حساب کاربری اقدام کند.
      </Text>
      <Text>
        11) هر شخص تنها می‌تواند یک حساب کاربری به عنوان کاربر یا استفاده‌کننده
        از خدمات اپلیکیشن داشته باشد. در صورتی که مدیریت اطلاع یابد که به نام یک
        شخص اعم از حقیقی و یا حقوقی حساب‌های کاربری متعدد وجود دارد، مجاز خواهد
        بود نسبت به قطع خدمات و غیرفعال کردن حساب‌های کاربری مذکور اقدام کند.
      </Text>
      <Text>
        12) مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری اشخاص حقیقی و یا
        حقوقی در اپلیکیشن یا سایر خدمات ارائه شده در اپلیکیشن انجام می‌شود، به
        عهدۀ کاربران است. بنابراین مسئولیت اشخاص ثالث یا افرادی غیر از کاربر که
        با آن حساب از خدمات اپلیکیشن استفاده می‌کنند، تماما متوجه کاربر
        صاحب‌حساب است. کاربر دارای حساب کاربری، دارای مسئولیت تضامنی در قبال
        اشخاص اعم از شرکت، سایر کاربران و اشخاص ثالث هستند.
      </Text>
      <Text>
        13) مسئولیت حفظ امنیت اطلاعات حساب کاربری شامل نام کاربری و شماره تلفن
        همراه، به عهدۀ کاربران می‌باشد. در صورت مفقود شدن یا به سرقت رفتن
        اطلاعات حساب کاربری و گوشی موبایل، کاربر مذکور موظف است در اسرع وقت
        موضوع را به اطلاع واحد پشتیبانی اپلیکیشن برساند. بدیهی است تا زمانی که
        اطلاع‌رسانی به پشتیبانی انجام نشده است، مسئولیت همۀ فعالیت‌هایی که از
        طریق حساب کاربری مذکور و موبایل کاربر انجام شده و می‌شود به عهدۀ وی
        خواهد بود.
      </Text>
      <Text>
        14) کاربران حق ندارند به سایر اشخاص حقیقی و حقوقی اجازه استفاده از حساب
        کاربری خود را بدهند یا حساب خود را به شخص حقیقی یا حقوقی دیگری منتقل
        کنند. در مورد کاربر شخص حقوقی نیز، مسئولیت‌های قانونی بهره‌‌برداری از
        خدمات اپلیکیشن متوجه مدیران اشخاص حقوقی خواهد بود.
      </Text>
      <Text>
        15) در شرایط خاصی ممکن است از کاربران برای استفاده از خدمات، درخواست
        احراز هویت مجدد شود، در این شرایط اگر کاربران اطلاعات کافی در اختیار
        واحد پشتیبانی قرار ندهند، مدیریت می‌تواند حساب کاربری آن‌ها را مسدود و
        از ارائۀ خدمات به نامبردگان خودداری کند.
      </Text>
      <Text>
        16) ممکن است بنا به مورد و حسب صلاحدید مدیریت، از کاربران درخواست شود که
        اقدام به تکمیل اطلاعات، ارائه مدارک و یا اصلاح اطلاعات موجود کنند. در
        این صورت، کاربر متعهد به ارائه اطلاعات و یا اصلاح اطلاعات درخواستی در
        مدت اعلام و درخواست شده از سوی مدیریت خواهد بود. در غیر این صورت مدیریت
        اپلیکیشن می‌تواند حساب کاربری وی را مسدود کرده و از ارائۀ خدمات به کاربر
        مذکور خودداری کند.
      </Text>
      <Text>
        17) با استفاده از خدمات اپلیکیشن شبکه خیر، کاربران می‌پذیرند و موظف
        هستند که از خدمات ارائه شده برای انجام هیچ فعالیت غیر‌قانونی طبق قوانین
        جمهوری اسلامی ایران، خلاف شرع و مخالف با عرف جامعه استفاده نکنند.
      </Text>
      <Text>
        18) در صورتی که کاربران نسبت به سوءاستفاده از امکانات فراهم شده در خدمات
        اپلیکیشن در جهت منافع شخصی و یا آسیب مادی یا معنوی به منافع شرکت اقدام
        کنند، مدیریت ضمن داشتن حق قطع خدمات و غیرفعال کردن حساب کاربری آن‌ها،
        مجاز خواهد بود، با مراجعه به مراجع ذیصلاح، نسبت به پیگیری قانونی از جمله
        مطالبه خسارات وارده اقدام کند.
      </Text>
      <Text>
        19) کاربران می‌پذیرند که اپلیکیشن ممکن است از ارسال پیامک، ایمیل و یا
        Push Notification به عنوان راه ارتباطی با آن‌ها استفاده کند. کاربران
        می‌توانند درخواست کنند که ارسال این پیام‌ها قطع شود، اما با انصراف از
        دریافت این پیام‌ها مشکلات احتمالی در استفاده از خدمات اپلیکیشن را
        می‌پذیرند و ممکن است اطلاعات مقتضی را به موقع دریافت نکنند.
      </Text>
      <Text>
        20) با استفاده از خدمات اپلیکیشن شبکه خیر، کاربران می‌پذیرند که در ثبت
        توانمندی یا نیازمندی، اپلیکیشن شبکه خیر را وسیله‌ای برای تبلیغات و
        بازاریابی کالا و خدمات شخصی خود قرار ندهند و از هرگونه فعالیت تبلیغاتی و
        غیر خیرخواهانه نظیر معرفی و عرضۀ محصولات و خدمات شخصی و یا متعلق به
        دیگران خودداری کنند.
      </Text>
      <Text>
        21) کاربران می‌پذیرند و اعلام می‌کنند که متن حریم خصوصی اپلیکیشن را
        مطالعه کرده و مورد قبول ایشان است
      </Text>
    </Warper>
  );
}
